// extracted by mini-css-extract-plugin
export default {"benefitsHolder":"Benefits_benefitsHolder__VRdmv","benefits":"Benefits_benefits__FMzUm","benefit":"Benefits_benefit__RNoAp","icons":"Benefits_icons__CGp6M"};